// src/components/shared/IconButtons.jsx
import React, { useState } from "react";
import {
  Edit,
  Trash2,
  Eye,
  MoreVertical,
  FileText,
  ArrowRight,
} from "lucide-react";

const ICONS = {
  edit: Edit,
  delete: Trash2,
  eye: Eye,
  doc: FileText,
  go: ArrowRight,
};

export default function IconButtons({
  layout = "horizontal",
  buttons = [],
  mobileMenu = true,
}) {
  const [open, setOpen] = useState(false);

  // ---------------  MOBILE: MENU "…" ----------------
  if (mobileMenu) {
    return (
      <div className="relative md:hidden">
        <button
          className="p-2 rounded-full hover:bg-gray-100"
          onClick={() => setOpen((o) => !o)}
        >
          <MoreVertical size={22} />
        </button>

        {open && (
          <div className="absolute right-0 mt-2 w-44 bg-white border border-gray-200 shadow-lg rounded-xl z-50">
            {buttons.map((btn, idx) => {
              const Icon = ICONS[btn.icon] || Eye;

              return (
                <button
                  key={idx}
                  className="flex items-center w-full px-3 py-2 text-sm text-left hover:bg-gray-50"
                  onClick={() => {
                    setOpen(false);
                    btn.onClick?.();
                  }}
                >
                  <Icon size={18} className="mr-2" />
                  {btn.label}
                </button>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  // ---------------  DESKTOP ----------------
  return (
    <div
      className={
        layout === "horizontal"
          ? "hidden md:flex items-center gap-2"
          : "hidden md:flex flex-col gap-2"
      }
    >
      {buttons.map((btn, idx) => {
        const Icon = ICONS[btn.icon] || Eye;

        return (
          <button
            key={idx}
            title={btn.label}
            onClick={btn.onClick}
            className="
              p-2 rounded-full border border-gray-200
              hover:bg-gray-100 hover:border-gray-300
              transition-all
            "
          >
            <Icon size={18} />
          </button>
        );
      })}
    </div>
  );
}
